import React, {useState, useEffect} from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederBetalingskalkulatorDto from '../Models/VeilederBetalingskalkulatorDto';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';
import { VeilederBetalingskalkulatorAppState } from '../Store';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';

interface SliderOwnProps {
    valg: ValgTypes.ValgState,
    locale: string,
    valuta?: string | null,
}

type SliderProps = SliderOwnProps & MapStateToProps & {};

const ResultatComponent = (props: SliderProps): JSX.Element => {
    const { epiContext } = props;
    const [visModal, setVisModal] = useState(false);
    
    function hentRenterIProsent(renter: string | undefined): number {
        if(renter === undefined)
            return 0;

        let renterParsed: number = parseFloat(renter);
        return renterParsed / 100;
    }

    useEffect(() => {
        updateLiveMessage();
    }, []);

    function regnUtTotalKostnad(lanebelop: string | undefined, renter: string | undefined, antallMaaneder: number | undefined): number {
        if(antallMaaneder === undefined)
            return 0;

        let terminBelop: number = regnUtTerminBelop(lanebelop, renter, antallMaaneder);
        let nedbetalingstid: number = Math.floor(antallMaaneder); 

        return terminBelop * nedbetalingstid;
    }

    function regnUtRenterIBetalingsPause(lanebelop: string | undefined, renter: string | undefined): number {
        if(lanebelop === undefined || renter === undefined)
            return 0;

        let lanebelopParsed: number = parseInt(lanebelop)
        let renterParsed: number = hentRenterIProsent(renter);

        if(renterParsed === 0)
            renterParsed = 0.0001;

        return (lanebelopParsed*Math.pow((1+(renterParsed/12)), 7))-lanebelopParsed;
    }

    function regnUtTerminBelop(lanebelop: string | undefined, renter: string | undefined, antallMaaneder: number): number {
        if(lanebelop === undefined || renter === undefined)
            return 0;

        let lanebelopParsed: number = parseInt(lanebelop);
        let renterParsed: number = hentRenterIProsent(renter);
        let nedbetalingstid: number = Math.floor(antallMaaneder); 
        
        if(nedbetalingstid === 0)
            nedbetalingstid = 1;

        if(renterParsed === 0) 
            renterParsed = 0.0001;

        let utregning: number = (((renterParsed/12)*(Math.pow(1+(renterParsed/12),nedbetalingstid))) / ((Math.pow(1+(renterParsed/12),nedbetalingstid))-1)) * (lanebelopParsed + regnUtRenterIBetalingsPause(lanebelop, renter));

        if(isNaN(utregning) || utregning === Infinity)
            return 0;

        return utregning;
    }

    function formatNumber(tall: any, locale: string): string {
        let tallSomString: string = tall.toString();

        if(locale === 'en-US') {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
        } else {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        }
        return tallSomString;
    }

    function hentTerminBelop(): number {
        if(props.valg.nedbetalingstidMaaneder === undefined)
            return 0;

        return Math.round(regnUtTerminBelop(props.valg.lanebelop?.value, props.valg.rente?.value, props.valg.nedbetalingstidMaaneder));
    }

    function erTerminBelop0(): boolean {
        if(hentTerminBelop() === 0)
            return true;

        return false;
    }

    function antallTerminerErUnderEttAar(): boolean {
        if(props.valg.nedbetalingstidMaaneder === undefined)
            return false;

        let antallTerminer = Math.round(props.valg.nedbetalingstidMaaneder) + 7;
        
        if(antallTerminer < 12)
            return true;

        return false;
    }

    function hentHjelpetekst(): keyof VeilederBetalingskalkulatorDto {
        if(erTerminBelop0()) {
            return 'tekstForResultat0'
        } else if(antallTerminerErUnderEttAar()) {
            return 'tekstForAntallTerminer'
        } else {
            return 'resultatTerminOverskrift'
        }
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
            <div className="c-veileder__content">
                <div className="c-veileder--mini-twocolumn-container c-veileder--mini-twocolumn-container-resultat">
                    <div className="c-veileder--mini-twocolumn-item  c-veileder--div-space-override">
                        <h4 className="c-veileder--mini-twocolumn-tittel">{contentResolver(epiContext, 'resultatOverskrift')}</h4>
                    </div>
                    <div className="c-veileder--mini-twocolumn-item">
                        <div className="c-veileder__resultat-tekst c-veileder--div-space-override">
                            <span>{formatNumber(hentTerminBelop(), props.locale)} </span>
                            <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                        </div>
                        <p className="c-veileder__tekst c-veileder__tekst--tett">{contentResolver(epiContext, hentHjelpetekst())}</p>
                        <div>
                            {contentResolver(epiContext, 'resultatTotalOverskrift')}&nbsp;
                            {formatNumber(Math.round(regnUtTotalKostnad(props.valg.lanebelop?.value, props.valg.rente?.value, props.valg.nedbetalingstidMaaneder)), props.locale)} {props.valuta}
                        </div>
                        <div className="c-veileder__tekst c-veileder__tekst--tett">
                            <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine c-veileder--div-spacer" onClick={() => setVisModal(true)}>
                                {contentResolver(epiContext, 'modalLenketekst')}
                            </button>
                            <ModalCompontent
                                isOpen={visModal}
                                onRequestClose={() => setVisModal(false)}
                                ariaCloseText={resolveRawText(epiContext, 'modalLukkTekst')}
                            >
                                <ArticleContentComponent
                                    headerinnhold={contentResolver(epiContext, 'modalTittel')}
                                    contentinnhold={contentResolver(epiContext, 'modalTekst')}
                                />
                            </ModalCompontent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederBetalingskalkulatorDto>;
}

export default connect(
    (state: VeilederBetalingskalkulatorAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(ResultatComponent);
